export default __webpack_public_path__ + "static/media/HTML5_logo_and_wordmark.aff8a9cb.svg";